'use client';

import { useFunnelSession } from '@/entities/session/model/funnel-session-context';
import { ENTRY_STEP_ID } from '@/shared/config/funnel/flowConstants';
import { emptyFunnelSession, funnelSessionReducer } from '../session/funnel-session-reducer';

export function useFunnelContextChanges() {
  const { reset } = useFunnelSession();

  const changeGoal = (goal: string): void => {
    reset(
      funnelSessionReducer(emptyFunnelSession, {
        type: 'record',
        stepId: ENTRY_STEP_ID,
        value: goal,
      }),
    );
  };

  return { changeGoal };
}
